"use client";

import { toast, type ToastOptions } from "react-toastify";
import {
  getApiErrorMessage,
  getApiErrorMessageFromData,
} from "@/lib/api-error";

const defaultOptions: ToastOptions = {
  position: "top-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export function showSuccessToast(
  message: string,
  options?: ToastOptions,
): void {
  toast.success(message, { ...defaultOptions, ...options });
}

export function showErrorToast(message: string, options?: ToastOptions): void {
  toast.error(message, { ...defaultOptions, autoClose: 5000, ...options });
}

export function showInfoToast(message: string, options?: ToastOptions): void {
  toast.info(message, { ...defaultOptions, ...options });
}

export function showApiErrorToast(
  error: unknown,
  fallback = "Something went wrong. Please try again.",
  options?: ToastOptions,
): void {
  showErrorToast(getApiErrorMessage(error, fallback), options);
}

export function showApiResponseErrorToast(
  data: unknown,
  fallback = "Something went wrong. Please try again.",
  options?: ToastOptions,
): void {
  showErrorToast(getApiErrorMessageFromData(data, fallback), options);
}
